module.exports = __webpack_public_path__ + "static/img/berny.7a02762.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/berny.png
// module id = 647
// module chunks = 64